<template>
  <div class="noselect">
    <!--        <div class="absBack">-->
    <!--            <div onclick="window.history.back()">-->
    <!--                <v-icon  medium dark>mdi-arrow-left</v-icon>-->
    <!--            </div>-->
    <!--        </div>-->

    <!--        <h1 class="myTitle tablet">Impressum</h1>-->

    <v-container grid-list-md>

      <div class="text-center mt-7">
        <h4>Setup Kiosk System</h4>

        <div class="spacer-15"></div>
        <div>
          isKiosk: {{ $store.getters.isKiosk }}
        </div>
        <div>
          table: {{ $store.getters.table }}
        </div>

        <div v-if="$store.getters.isKiosk">
          <div class="spacer-15"></div>

          <!--          <div class="superCenter">-->
          <!--            <div class="d-inline-block myBox">-->
          <!--              <h3>Config Params:</h3>-->
          <!--              <v-text-field-->
          <!--                v-model="adminSid"-->
          <!--                label="Admin SID"-->
          <!--                outlined hide-details-->
          <!--              ></v-text-field>-->
          <!--            </div>-->
          <!--          </div>-->

          <div class="superCenter">
            <div class="d-inline-block myBox">
              <!--              <v-text-field-->
              <!--                v-model="terminalIpAddress"-->
              <!--                label="Terminal IP Address"-->
              <!--                outlined hide-details-->
              <!--              ></v-text-field>-->

              <v-text-field
                  v-model="doubleValue"
                  label="Betrag (inkl. Trinkgeld)"
                  type="number"
                  step="0.01"
                  :rules="[validateDouble]"
                  outlined hide-details
              ></v-text-field>

              <v-text-field
                  v-model="doubleTrinkgeld"
                  label="Trinkgeld (optional)"
                  type="number"
                  step="0.01"
                  :rules="[validateDouble]"
                  outlined hide-details
              ></v-text-field>

              <v-btn color="btn-df"
                     @click="triggerTerminalPayment"
              >
                Trigger Payment
              </v-btn>
            </div>
          </div>

          <div class="superCenter">
            <div class="d-inline-block myBox">
              <h3>Output Params:</h3>
              <div>Last Update: {{ lastUpdateOutputParams }}</div>
              <div style="white-space: pre">{{ paramsString }}</div>
            </div>
          </div>

          <div class="superCenter">
            <div class="d-inline-block myBox">
              <div class="flex">
                <h3>All Params:</h3>
                <v-spacer></v-spacer>
                <v-btn class="btn-mini"
                       @click="readAllParams"
                >Refresh
                </v-btn>
              </div>
              <div style="white-space: pre">{{ allParamsString }}</div>
            </div>
          </div>

          <v-btn color="btn-df"
                 @click="checkTerminalServiceActive"
          >
            Check Terminal Service active
          </v-btn>
          <div class="spacer-15"></div>
          <v-btn color="btn-df"
                 @click="getCurrentTerminalIp"
          >
            Get current terminal IP
          </v-btn>
          <div class="spacer-15"></div>
          <v-btn color="btn-df"
                 @click="clickTriggerDiagnose"
          >
            Trigger Diagnose
          </v-btn>

          <div class="spacer-15"></div>
          <v-btn color="btn-df"
                 @click="finishSetup"
          >
            Finish Setup and Open Start Page
          </v-btn>
        </div> <!--          eof kiosk=true-->

        <div class="spacer-20"></div>
        <div class="mb-4">
          <v-btn color="btn-mini"
                 @click="clickDebugParams"
          >
            Öffne Konfigurationsparameter
          </v-btn>
        </div>
        <div class="mb-4">
          <v-btn color="btn-mini"
                 @click="clickSetupShowHide"
          >
            Setup Button aus/einblenden
          </v-btn>
        </div>
        <div class="mb-4">
          <v-btn color="btn-mini"
                 @click="clickBestellungen"
          >
            Letzte Bestellungen
          </v-btn>
        </div>
        <div class="mb-4">
          <v-btn color="btn-mini"
                 @click="dummyPrint"
          >
            Print Dummy Page
          </v-btn>
        </div>


        <div class="spacer-40"></div>
        <v-btn color="btn-mini"
               @click="exitKiosk"
        >
          Exit Kiosk Mode
        </v-btn>

      </div>


    </v-container>


    <!--    <DummyZvtDialog-->
    <!--        :total="22"-->
    <!--        :dialog="showDummyDialog"-->
    <!--        ></DummyZvtDialog>-->

  </div>
</template>

<script>

import store from "../store/store";
import {ebus} from "../vendor/ebus";
import * as util from "../vendor/util";
import {clearEvents, clearTheInterval, doReload, isEmptyObject} from "../vendor/util";
import * as qconst from "../vendor/qconstants";
// import DummyZvtDialog from "../dialogs/DummyZvtDialog.vue";
import ZvtDialog from "../dialogs/ZvtDialog.vue";

export default {
  components: {ZvtDialog},
  data: () => ({
    iv1: null,
    doubleValue: null,
    doubleTrinkgeld: null,
    params: null,
    allParams: null,
    lastUpdateOutputParams: 0,

    showDummyDialog: false,
  }),

  created() {
    ebus.$on('cb-postToWindowskiosk', (resp) => {
      console.log('receive callback from cb-postToWindowskiosk');
      if (resp && !isEmptyObject(resp)) {
        const responseAction = '' + resp.action;
        delete resp.action;

        if (responseAction === 'triggerPosTerminal') {
          ebus.$emit('showInfo', {
            title: 'trigger response: ' + JSON.stringify(resp, null, 2),
            // text: 'Vielen Dank!'
          });
        } else if (responseAction === 'readStatusFromTerminal') {
          this.handleZvtStatusResponse(resp);
        } else if (responseAction === 'readErgebnisFromTerminal') {
          this.params = resp;
        } else if (responseAction === 'readAllParams') {
          this.allParams = resp;
        } else if (responseAction === 'checkTerminalServiceActive') {
          if (!(resp.ok && resp.configSetupCompleted)) {
            ebus.$emit('showInfo', {
              title: 'WARNING: The device setup is incomplete. Please contact the administrator',
              text: 'Setup check response: ' + JSON.stringify(resp),
            });
          } else {
            ebus.$emit('showInfo', {
              title: 'Setup check response: ' + JSON.stringify(resp),
              // text: 'Vielen Dank!'
            });
          }
        } else if (responseAction === 'getCurrentTerminalIp') {
          ebus.$emit('showInfo', {
            title: 'response: ' + JSON.stringify(resp, null, 2),
            // text: 'Vielen Dank!'
          });
        } else if (responseAction === 'triggerDiagnose') {
          ebus.$emit('showInfo', {
            title: 'diagnose response: ' + JSON.stringify(resp, null, 2),
            // text: 'Vielen Dank!'
          });
        } else if (responseAction === 'dummyPrint') {
          ebus.$emit('showInfo', {
            title: 'dummyPrint response: ' + JSON.stringify(resp, null, 2),
            // text: 'Vielen Dank!'
          });
        }
      }
    });

  },

  mounted() {
    this.initIv();
    store.commit('showLoading', false);
  },

  destroyed() {
    clearEvents([
      'cb-postToWindowskiosk',
    ]);
    clearInterval(this.iv1);
  },

  computed: {
    paramsString() {
      if (!this.params) {
        return "loading...";
      }
      return JSON.stringify(this.params, null, 2);
    },

    allParamsString() {
      if (!this.allParams) {
        return "";
      }
      return JSON.stringify(this.allParams, null, 2);
    },

  },

  methods: {
    dummyPrint() {
      ebus.$emit('postToWindowskiosk', {
        action: 'dummyPrint',
        cb: 'cb-dummyPrint'
      });
    },

    clickSetupShowHide() {
      store.commit('hideSetupButton', !store.getters.hideSetupButton);
    },

    clickDebugParams() {
      ebus.$emit('goto', {name: 'debugParams'});
    },

    initIv() {
      if (this.iv1) {
        clearTheInterval(this.iv1);
      }

      this.iv1 = setInterval(() => {
        this.lastUpdateOutputParams = Date.now();
        this.readErgebnisFromTerminal();
      }, 3 * 1000);
    },

    validateDouble(value) {
      if (value === null || value === '') return true;
      return !isNaN(value) && !isNaN(parseFloat(value)) || 'Must be a valid number';
    },

    getCurrentTerminalIp() {
      ebus.$emit('postToWindowskiosk', {
        action: 'getCurrentTerminalIp',
        cb: 'cb-postToWindowskiosk'
      });
    },

    clickTriggerDiagnose() {
      ebus.$emit('postToWindowskiosk', {
        action: 'triggerDiagnose',
        cb: 'cb-postToWindowskiosk'
      });
    },

    readAllParams() {
      this.allParams = null;
      ebus.$emit('postToWindowskiosk', {
        action: 'readAllParams',
        cb: 'cb-postToWindowskiosk'
      });
    },

    readErgebnisFromTerminal() {
      ebus.$emit('postToWindowskiosk', {
        action: 'readErgebnisFromTerminal',
        //terminalId: '' + store.getters.table,
        cb: 'cb-postToWindowskiosk'
      });
    },

    triggerTerminalPayment() {
      console.log('testTriggerPosTerminal clicked');
      if (!store.getters.isKiosk) {
        return;
      }

      console.log('emit postToWindowskiosk');
      ebus.$emit('postToWindowskiosk', {
        action: 'triggerPosTerminal',
        uniqueOrderId: 'test-uniqueOrderId',
        betrag: 0 + this.doubleValue,
        trinkgeld: this.doubleTrinkgeld ? this.doubleTrinkgeld : 0,
        cb: 'cb-postToWindowskiosk'
      });

    },

    clickBestellungen() {
      this.$router.replace({name: 'Bestellungen'});
    },

    checkTerminalServiceActive() {
      console.log('checkTerminalServiceActive clicked');
      if (!store.getters.isKiosk) {
        return;
      }

      console.log('emit postToWindowskiosk');
      ebus.$emit('postToWindowskiosk', {
            action: 'checkTerminalServiceActive',
        cb: 'cb-postToWindowskiosk'
      });

    },

    finishSetup() {
      this.$router.replace({name: 'Home'});
    },

    exitKiosk() {
      this.$ls.remove('kioskTable');
      store.commit('setIsKiosk', false);
      store.commit('setShowKioskSplashOnHome', false);
      store.commit('setEnableOrderModeSelection', false);
      store.commit('setEnableOrderModeSelectionWithTime', false);
      ebus.$emit('clearInhouseModus', {eventSource: 'exitKiosk'});
      this.$ls.remove('kioskTable');
      //   doReload('exitKiosk');

      //reload is required to load the default parameters again
      setTimeout(() => {
        doReload('exitKiosk');
      }, 500);

      this.$router.replace({name: 'Home'});
    },


  }
}
</script>

<style scoped lang="scss">
@import '../styles/base';

.myBox {
  padding: 30px;
  margin: 20px;
  border: 2px solid black;;
  border-radius: $box-border-radius;
  background-color: white;
  min-width: 600px;
  max-width: 1000px;
  overflow-x: hidden;
}
</style>
